// Local feedback only; Horizon continues to resolve variant ID, inventory and price.
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
  const picker = input.closest('variant-picker');
  const fieldset = input.closest('.variant-option');
  if (!picker || !fieldset) return;
  const label = fieldset.querySelector('.variant-option__selected-value, .variant-option__swatch-value');
  if (label) label.textContent = input.value;
});
